<template>
    <div>
        <repayment-apply-activation v-if="baseInfo.hasFinanceAccount || baseInfo.nextStage > 0"/>
        <!--未进行产融还款专户开户申请-->
        <repayment-not-opened v-else :baseInfo="baseInfo"/>
    </div>
</template>

<script>
    import api from '@/modules/projectA/api/pay/index';
    import repaymentApplyActivation from './repaymentApplyActivation';
    import repaymentNotOpened from './repaymentNotOpened';
    export default {
        name: "index",
        components:{
            repaymentApplyActivation,
            repaymentNotOpened
        },
        data(){
            return{
                baseInfo:{},
            }
        },
        methods:{
            async financeAccountStatus(){
                let res = await api.financeAccountStatus();
                if(res.success){
                    this.baseInfo = res.data;
                    console.log( this.baseInfo ,' this.baseInfo ')
                }
            },
        },
        mounted() {
            this.financeAccountStatus();
        }

    }
</script>

<style scoped lang="scss">

</style>